import { Injectable } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { Observable, of } from 'rxjs';
import { MxTableColumn } from 'src/app/shared/domains/common/interfaces';
import { MxColumnType } from 'src/app/shared/enums';
import {
  MxDateFormatPipe,
  MxFirstLetterOperationPipe,
} from 'src/app/shared/pipes';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root',
})
export class MxExportService {
  constructor(
    private i18nextPipe: I18NextPipe,
    private firstLetterOperationPipe: MxFirstLetterOperationPipe,
    private dateFormatPipe: MxDateFormatPipe
  ) {}

  excelExport(
    datasource: any[],
    columns: MxTableColumn[],
    fileName: string
  ): Observable<any[]> {
    const dsOut: any[] = [];

    datasource.forEach((val) => {
      const value = Object.assign({}, val);
      const newValue: any = {};

      Object.keys(value).forEach((key) => {
        const col = columns.find((f) => f.field === key);
        if (col) {
          this.transformData(col, value);
          newValue[
            this.i18nextPipe.transform(
              `field:${
                col.header
                  ? this.firstLetterOperationPipe.transform(col.header)
                  : this.firstLetterOperationPipe.transform(col.field)
              }`
            )
          ] = value[key];
        }
      });

      dsOut.push(Object.assign({}, newValue));
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dsOut);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, fileName);
    XLSX.writeFile(workbook, `${fileName}_export_${new Date().getTime()}.xlsx`);

    return of(dsOut);
  }

  private transformData(col: MxTableColumn, data: any): void {
    if (col.type === MxColumnType.Boolean) {
      data[col.field] = data[col.field]
        ? this.i18nextPipe.transform('Yes')
        : this.i18nextPipe.transform('No');
    } else if (col.type === MxColumnType.Enum) {
      data[col.field] = this.i18nextPipe.transform(
        `enum:${col.enumName}.${col.enum[data[col.field]]}`
      );
    } else if (col.type === MxColumnType.Number && col.isPercentage) {
      data[col.field] = data[col.field] * 100;

    } else if (col.type === MxColumnType.Date) {
      data[col.field] = this.dateFormatPipe.transform(
        data[col.field],
        'YYYY.MM.DD.'
      );
    } else if (col.type === MxColumnType.DateTime) {
      data[col.field] = this.dateFormatPipe.transform(
        data[col.field],
        'YYYY.MM.DD. HH:mm'
      );
    }

    if (col.prefix) {
      data[col.field] = `${col.prefix}${data[col.field]}`;
    }

    if (col.suffix) {
      data[col.field] = `${data[col.field]}${col.suffix}`;
    }
  }
}
